import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class StatementsConfiguration  {
    _originalTypeClassName = "zERP.BO.StatementsConfiguration";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
StatementsConfiguration.translate = translateService;
}
this.Bank = new Domain.Bank();
this.InvoiceTemplate = new Domain.InvoiceTemplate();
this.Id = null;
this.TransactionCode = null;
this.RF = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
TransactionCode:any;
RF:any;
Bank:any;
InvoiceTemplate:any;
static setBank = ($this, value) => {
var oldValue = $this.Bank;
$this.Bank = value;
if (value != null) {
if (oldValue != null) {
Domain.Bank.removeStatementsConfiguration(oldValue, $this);
}
Domain.Bank.addStatementsConfiguration(value, $this);
}
}
static setInvoiceTemplate = ($this, value) => {
var oldValue = $this.InvoiceTemplate;
$this.InvoiceTemplate = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}